const DRIPSTOCK_BODY_SIZE_CHART = [
  { size: 'XS', height: [150, 158], weight: [40, 47], source: 'chart' },
  { size: 'S', height: [157, 163], weight: [45, 51], source: 'chart' },
  { size: 'M', height: [162, 170], weight: [50, 58], source: 'chart' },
  { size: 'L', height: [168, 176], weight: [57, 67], source: 'chart' },
  { size: 'XL', height: [174, 183], weight: [65, 78], source: 'chart' },
  { size: '2XL', height: [180, 190], weight: [76, 90], source: 'chart' },
  { size: '3XL', height: [185, 195], weight: [88, 105], source: 'chart' },
  { size: '4XL', height: [190, 205], weight: [103, 120], source: 'extended' }
];



const DRIPSTOCK_OVERSIZED_HOODIE_BODY_CHART = [
  { size: 'XS', height: [150, 158], weight: [40, 48], source: 'oversized-hoodie-fit' },
  { size: 'S', height: [155, 164], weight: [45, 55], source: 'oversized-hoodie-fit' },
  { size: 'M', height: [160, 171], weight: [52, 64], source: 'oversized-hoodie-fit' },
  { size: 'L', height: [167, 179], weight: [60, 76], source: 'oversized-hoodie-fit' },
  { size: 'XL', height: [174, 185], weight: [72, 86], source: 'oversized-hoodie-fit' },
  { size: '2XL', height: [180, 192], weight: [84, 100], source: 'oversized-hoodie-fit' },
  { size: '3XL', height: [186, 198], weight: [98, 114], source: 'oversized-hoodie-fit' },
  { size: '4XL', height: [192, 205], weight: [112, 130], source: 'oversized-hoodie-fit' }
];

const DRIPSTOCK_SWEATPANT_BODY_CHART = [
  { size: 'XS', height: [150, 160], weight: [40, 50], source: 'sweatpants-fit' },
  { size: 'S', height: [155, 168], weight: [45, 58], source: 'sweatpants-fit' },
  { size: 'M', height: [162, 176], weight: [53, 70], source: 'sweatpants-fit' },
  { size: 'L', height: [170, 184], weight: [64, 84], source: 'sweatpants-fit' },
  { size: 'XL', height: [178, 190], weight: [82, 98], source: 'sweatpants-fit' },
  { size: '2XL', height: [184, 196], weight: [94, 110], source: 'sweatpants-fit' },
  { size: '3XL', height: [190, 203], weight: [106, 124], source: 'sweatpants-fit' },
  { size: '4XL', height: [196, 210], weight: [120, 140], source: 'sweatpants-fit' }
];

const DRIPSTOCK_SWEATPANT_MEASUREMENTS = {
  S: { waist: 48, length: 99 },
  M: { waist: 52, length: 102 },
  L: { waist: 54, length: 104 },
  XL: { waist: 57, length: 107 },
  '2XL': { waist: 60, length: 110 }
};

function normalizeSize(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/^XXXXL$/, '4XL')
    .replace(/^XXXL$/, '3XL')
    .replace(/^XXL$/, '2XL');
}

function parseMeasurement(value) {
  const cleaned = String(value || '').replace(/[^\d.]/g, '');
  const number = Number(cleaned);
  return Number.isFinite(number) ? number : NaN;
}

function normalizedRangeDistance(value, min, max) {
  const span = Math.max(1, max - min);
  if (value < min) return 1 + (min - value) / span;
  if (value > max) return 1 + (value - max) / span;
  const center = (min + max) / 2;
  return Math.abs(value - center) / span * 0.22;
}

function availableSizesFromPicker(picker) {
  if (!picker) return [];

  const sizes = [];
  const radios = Array.from(picker.querySelectorAll('input[data-option-name="Size"]'));
  radios.forEach((input) => {
    const unavailable =
      input.disabled ||
      input.getAttribute('aria-disabled') === 'true' ||
      input.dataset.optionAvailable === 'false';
    if (!unavailable) sizes.push(normalizeSize(input.value));
  });

  const selects = Array.from(picker.querySelectorAll('select'));
  selects.forEach((select) => {
    const container = select.closest('.variant-option');
    if (!container || !/size/i.test(container.textContent || '')) return;
    Array.from(select.options).forEach((option) => {
      if (!option.disabled) sizes.push(normalizeSize(option.value));
    });
  });

  return [...new Set(sizes.filter(Boolean))];
}

function recommendFromChart(height, weight, picker, chart) {
  const available = availableSizesFromPicker(picker);
  let rows = chart;

  if (available.length) {
    const filtered = rows.filter((row) => available.includes(row.size));
    if (filtered.length) rows = filtered;
  }

  return rows
    .map((row) => {
      const inHeight = height >= row.height[0] && height <= row.height[1];
      const inWeight = weight >= row.weight[0] && weight <= row.weight[1];

      const exactBonus = inHeight && inWeight ? -1.2 : 0;
      const heightDistance = normalizedRangeDistance(height, row.height[0], row.height[1]);
      const weightDistance = normalizedRangeDistance(weight, row.weight[0], row.weight[1]);

      return {
        ...row,
        inHeight,
        inWeight,
        score: heightDistance * 0.42 + weightDistance * 0.58 + exactBonus
      };
    })
    .sort((a, b) => a.score - b.score)[0];
}

function isOversizedHoodie(picker) {
  if (!picker) return false;

  const selectedFit = getSelectedFit(picker);
  if (/oversized/i.test(selectedFit)) return true;
  if (/regular/i.test(selectedFit)) return false;

  const productText = [
    picker.dataset.productTitle || '',
    picker.dataset.productHandle || ''
  ].join(' ');

  return /oversized/i.test(productText);
}

function recommendHoodieSizeByFit(height, weight, picker, fitChoice) {
  const chart = /oversized/i.test(fitChoice)
    ? DRIPSTOCK_OVERSIZED_HOODIE_BODY_CHART
    : DRIPSTOCK_BODY_SIZE_CHART;

  return recommendFromChart(height, weight, picker, chart);
}

function recommendBodySize(height, weight, picker) {
  const chart = isOversizedHoodie(picker)
    ? DRIPSTOCK_OVERSIZED_HOODIE_BODY_CHART
    : DRIPSTOCK_BODY_SIZE_CHART;

  return recommendFromChart(height, weight, picker, chart);
}

function recommendSweatpantsSize(height, weight, picker) {
  return recommendFromChart(height, weight, picker, DRIPSTOCK_SWEATPANT_BODY_CHART);
}

function getFitChoiceFromFinder(form) {
  const selected = form.querySelector('input[name="fit_preference"]:checked');
  return selected ? String(selected.value || '').trim() : 'Regular';
}

function getSelectedFit(picker) {
  if (!picker) return '';
  const checked = picker.querySelector('input[data-option-name="Fit"]:checked');
  if (checked) return String(checked.value || '').trim();

  const fitSelect = Array.from(picker.querySelectorAll('select')).find((select) => {
    const container = select.closest('.variant-option');
    return container && /fit/i.test(container.textContent || '');
  });

  return fitSelect ? String(fitSelect.value || '').trim() : '';
}

function getFitControl(picker, targetFit) {
  if (!picker || !targetFit) return null;
  const normalizedTarget = String(targetFit).trim().toLowerCase();

  const inputs = Array.from(picker.querySelectorAll('input[data-option-name="Fit"]'));
  const input = inputs.find((el) => {
    const unavailable =
      el.disabled ||
      el.getAttribute('aria-disabled') === 'true' ||
      el.dataset.optionAvailable === 'false';

    return !unavailable && String(el.value || '').trim().toLowerCase() === normalizedTarget;
  });
  if (input) return input;

  const selects = Array.from(picker.querySelectorAll('select'));
  for (const select of selects) {
    const container = select.closest('.variant-option');
    if (!container || !/fit/i.test(container.textContent || '')) continue;

    const option = Array.from(select.options).find(
      (opt) =>
        !opt.disabled &&
        String(opt.value || '').trim().toLowerCase() === normalizedTarget
    );

    if (option) return { select, option };
  }

  return null;
}

function selectFitControl(control) {
  if (!control) return false;

  if (control instanceof HTMLInputElement) {
    if (!control.checked) control.click();
    return true;
  }

  if (control.select && control.option) {
    if (control.select.value !== control.option.value) {
      control.select.value = control.option.value;
      control.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  return false;
}

function getSizeControl(picker, targetSize) {
  if (!picker) return null;
  const normalizedTarget = normalizeSize(targetSize);

  const inputs = Array.from(picker.querySelectorAll('input[data-option-name="Size"]'));
  const input = inputs.find((el) => {
    const unavailable =
      el.disabled ||
      el.getAttribute('aria-disabled') === 'true' ||
      el.dataset.optionAvailable === 'false';
    return !unavailable && normalizeSize(el.value) === normalizedTarget;
  });
  if (input) return input;

  const selects = Array.from(picker.querySelectorAll('select'));
  for (const select of selects) {
    const container = select.closest('.variant-option');
    if (!container || !/size/i.test(container.textContent || '')) continue;

    const option = Array.from(select.options).find(
      (opt) => !opt.disabled && normalizeSize(opt.value) === normalizedTarget
    );

    if (option) return { select, option };
  }

  return null;
}

function selectRecommendedSize(control) {
  if (!control) return false;

  if (control instanceof HTMLInputElement) {
    control.click();
    return true;
  }

  if (control.select && control.option) {
    control.select.value = control.option.value;
    control.select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  return false;
}

function playTaDa() {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (AudioContextClass) {
      const ctx = new AudioContextClass();
      const now = ctx.currentTime;
      const notes = [
        { frequency: 523.25, start: 0, duration: 0.12 },
        { frequency: 659.25, start: 0.11, duration: 0.13 },
        { frequency: 783.99, start: 0.23, duration: 0.28 }
      ];

      notes.forEach((note) => {
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(note.frequency, now + note.start);
        gain.gain.setValueAtTime(0.0001, now + note.start);
        gain.gain.exponentialRampToValueAtTime(0.16, now + note.start + 0.025);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + note.start + note.duration);
        oscillator.connect(gain);
        gain.connect(ctx.destination);
        oscillator.start(now + note.start);
        oscillator.stop(now + note.start + note.duration + 0.02);
      });

      window.setTimeout(() => ctx.close().catch(() => {}), 900);
    }
  } catch (_) {}


}

function closeOnBackdrop(event, dialog) {
  if (!(dialog instanceof HTMLDialogElement)) return;
  if (event.target !== dialog) return;

  const rect = dialog.getBoundingClientRect();
  const outside =
    event.clientX < rect.left ||
    event.clientX > rect.right ||
    event.clientY < rect.top ||
    event.clientY > rect.bottom;

  if (outside) dialog.close();
}

function showFinderForm(dialog) {
  const form = dialog.querySelector('[data-find-my-size-form]');
  const result = dialog.querySelector('[data-find-my-size-result]');
  if (form) form.hidden = false;
  if (result) result.hidden = true;
}

function isolateSizeAssistantInput(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || !target.matches('[data-find-my-size-input]')) return;

  const cleaned = target.value.replace(/\D/g, '').slice(0, 3);
  if (target.value !== cleaned) target.value = cleaned;

  event.stopPropagation();
}

if (!window.__dripstockSizingToolsBoundV2) {
  window.__dripstockSizingToolsBoundV2 = true;

  window.addEventListener('input', isolateSizeAssistantInput, true);
  window.addEventListener('change', isolateSizeAssistantInput, true);

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const chartTrigger = target.closest('[data-essentials-size-chart-open]');
    if (chartTrigger) {
      const dialogId = chartTrigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
      return;
    }

    const chartClose = target.closest('[data-essentials-size-chart-close]');
    if (chartClose) {
      chartClose.closest('dialog')?.close();
      return;
    }

    const finderTrigger = target.closest('[data-find-my-size-open]');
    if (finderTrigger) {
      const dialogId = finderTrigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;

      if (dialog instanceof HTMLDialogElement) {
        showFinderForm(dialog);
        const error = dialog.querySelector('[data-find-my-size-error]');
        if (error) error.hidden = true;
        if (!dialog.open) dialog.showModal();
        window.setTimeout(
          () => dialog.querySelector('input[name="height"]')?.focus(),
          40
        );
      }
      return;
    }

    const finderClose = target.closest('[data-find-my-size-close]');
    if (finderClose) {
      finderClose.closest('dialog')?.close();
      return;
    }

    const tryAgain = target.closest('[data-find-my-size-again]');
    if (tryAgain) {
      const dialog = tryAgain.closest('[data-find-my-size-dialog]');
      if (dialog) {
        showFinderForm(dialog);
        dialog.querySelector('input[name="height"]')?.focus();
      }
      return;
    }

    const useSize = target.closest('[data-find-my-size-use]');
    if (useSize) {
      const dialog = useSize.closest('[data-find-my-size-dialog]');
      const size = useSize.getAttribute('data-recommended-size');
      const fit = useSize.getAttribute('data-recommended-fit') || '';
      const picker = dialog?.closest('variant-picker');

      if (!picker) return;

      const fitControl = fit ? getFitControl(picker, fit) : null;
      if (fitControl) selectFitControl(fitControl);

      window.setTimeout(() => {
        const livePicker =
          document.querySelector(
            'variant-picker[data-product-id="' + (picker.dataset.productId || '') + '"]'
          ) || picker;

        const sizeControl = getSizeControl(livePicker, size);

        if (selectRecommendedSize(sizeControl)) {
          const liveDialog = document.getElementById(dialog?.id || '');
          liveDialog?.close();
        } else {
          const liveDialog = document.getElementById(dialog?.id || '') || dialog;
          const detail = liveDialog?.querySelector('[data-find-my-size-detail]');
          if (detail) {
            detail.textContent =
              'Your recommended size is ' +
              size +
              (fit ? ' in ' + fit + ' fit' : '') +
              ', but that combination is not currently selectable on this product.';
          }
        }
      }, fitControl ? 180 : 0);

      return;
    }

    const finderDialog = target.closest('[data-find-my-size-dialog]');
    if (finderDialog) {
      closeOnBackdrop(event, finderDialog);
      return;
    }

    const sizeDialog = target.closest('[data-essentials-size-chart-dialog]');
    if (sizeDialog) closeOnBackdrop(event, sizeDialog);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-find-my-size-form]')) return;

    event.preventDefault();
    event.stopPropagation();

    const dialog = form.closest('[data-find-my-size-dialog]');
    if (!dialog) return;

    const height = parseMeasurement(form.elements.height?.value);
    const weight = parseMeasurement(form.elements.weight?.value);
    const error = dialog.querySelector('[data-find-my-size-error]');

    if (!Number.isFinite(height) || !Number.isFinite(weight)) {
      if (error) {
        error.textContent = 'Enter both your height and weight.';
        error.hidden = false;
      }
      return;
    }

    if (height < 120 || height > 230 || weight < 25 || weight > 200) {
      if (error) {
        error.textContent = 'Please enter a realistic height in cm and weight in kg.';
        error.hidden = false;
      }
      return;
    }

    if (error) error.hidden = true;

    const picker = dialog.closest('variant-picker');
    const kind = dialog.dataset.productKind || 'hoodie';
    const isSweatpants = kind === 'sweatpants';
    const isSet = kind === 'set';
    const isStandardSizing = isSweatpants || isSet;
    const fitChoice = isStandardSizing ? 'Standard' : 'Oversized';
    const recommendation = isStandardSizing
      ? recommendSweatpantsSize(height, weight, picker)
      : recommendHoodieSizeByFit(height, weight, picker, 'Oversized');
    const fit = isStandardSizing ? 'Standard' : 'Oversized';

    const value = dialog.querySelector('[data-find-my-size-value]');
    const detail = dialog.querySelector('[data-find-my-size-detail]');
    const measurements = dialog.querySelector('[data-find-my-size-measurements]');
    const fitNote = dialog.querySelector('[data-find-my-size-fit]');
    const result = dialog.querySelector('[data-find-my-size-result]');
    const useButton = dialog.querySelector('[data-find-my-size-use]');

    if (value) value.textContent = recommendation.size;

    const exact = recommendation.inHeight && recommendation.inWeight;
    const sourceText =
      recommendation.source === 'sweatpants-fit'
        ? 'using Dripstock sweatpants fit data'
        : recommendation.source === 'oversized-hoodie-fit'
          ? 'using Dripstock oversized hoodie fit data'
          : recommendation.source === 'extended'
            ? 'using the extended Dripstock sizing pattern'
            : 'using the Dripstock size chart';

    if (detail) {
      detail.textContent =
        exact && recommendation.source === 'chart'
          ? height +
            ' cm · ' +
            weight +
            ' kg falls directly inside the ' +
            recommendation.size +
            ' range.'
          : height +
            ' cm · ' +
            weight +
            ' kg is best matched to ' +
            recommendation.size +
            ' ' +
            sourceText +
            '.';
    }

    if (measurements) {
      if (isSweatpants && DRIPSTOCK_SWEATPANT_MEASUREMENTS[recommendation.size]) {
        const pant = DRIPSTOCK_SWEATPANT_MEASUREMENTS[recommendation.size];
        measurements.textContent =
          'Sweatpants chart: ' +
          pant.waist +
          ' cm waist width · ' +
          pant.length +
          ' cm total length.';
        measurements.hidden = false;
      } else if (isSweatpants) {
        measurements.textContent =
          'This sweatpants size is recommended from height and weight. Exact garment measurements for this size are not yet verified in the current chart.';
        measurements.hidden = false;
      } else {
        measurements.hidden = true;
        measurements.textContent = '';
      }
    }

    if (fitNote) {
      if (isStandardSizing) {
        fitNote.textContent = 'Fit: Standard.';
        fitNote.hidden = false;
      } else if (!isSweatpants && /oversized/i.test(fit)) {
        fitNote.textContent =
          'Fit: Oversized. Recommended size ' +
          recommendation.size +
          ' is based on the oversized hoodie cut.';
        fitNote.hidden = false;
      } else if (!isSweatpants && /regular/i.test(fit)) {
        fitNote.textContent =
          'Fit selected: Regular. Recommended size ' +
          recommendation.size +
          ' is based on the regular hoodie cut.';
        fitNote.hidden = false;
      } else if (fit) {
        fitNote.textContent = 'Current fit selection: ' + fit + '.';
        fitNote.hidden = false;
      } else {
        fitNote.hidden = true;
        fitNote.textContent = '';
      }
    }

    if (useButton) {
      const fitControl = !isStandardSizing && fit ? getFitControl(picker, fit) : null;
      const sizeSelectable = Boolean(getSizeControl(picker, recommendation.size));
      const productHasFitOption = Boolean(
        picker?.querySelector('input[data-option-name="Fit"], select option[data-option-name="Fit"]')
      );
      const fitSelectable = isStandardSizing || !productHasFitOption || Boolean(fitControl);
      const selectable = sizeSelectable && fitSelectable;

      useButton.setAttribute('data-recommended-size', recommendation.size);
      useButton.setAttribute('data-recommended-fit', isStandardSizing ? '' : fit);
      useButton.disabled = !selectable;
      useButton.style.opacity = selectable ? '' : '0.55';
      useButton.textContent = selectable
        ? 'Use ' + (isStandardSizing ? '' : fit + ' ') + recommendation.size
        : 'Recommended: ' + (isStandardSizing ? '' : fit + ' ') + recommendation.size;
    }

    form.hidden = true;
    if (result) result.hidden = false;
    playTaDa();
  });
}
